var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9595A7",
    d: "M16.667 6.667v6.667h1.666V6.667zM15 15.001H5v1.666h10zM3.333 13.334V6.667H1.667v6.667zM5 5.001h10V3.334H5zm12.127 1.338-6.382 3.19.746 1.491 6.381-3.19zm-7.873 3.19L2.873 6.34l-.746 1.49L8.51 11.02zm-5.92-2.862c0-.92.745-1.666 1.666-1.666V3.334a3.333 3.333 0 0 0-3.333 3.333zM5 15.001c-.92 0-1.667-.746-1.667-1.667H1.667A3.333 3.333 0 0 0 5 16.667zm11.667-1.667c0 .92-.747 1.667-1.667 1.667v1.666a3.333 3.333 0 0 0 3.333-3.333zM10.744 9.53a1.67 1.67 0 0 1-1.49 0l-.746 1.49c.939.47 2.043.47 2.982 0zm7.588-2.863A3.333 3.333 0 0 0 15 3.334v1.667c.92 0 1.666.746 1.666 1.666z"
  })));
};
export default SvgIconEmail;